<template>
  <div class="order-page">
    <!-- 筛选栏 -->
    <el-card class="filter-card" shadow="never">
      <div class="fg-row">
        <el-input
          v-model="keyword"
          class="fg-search"
          prefix-icon="el-icon-search"
          placeholder="搜索客户姓名 / 手机号 / 订单号"
          clearable
          @keyup.enter.native="reload"
          @clear="reload"
        />
        <el-button type="primary" icon="el-icon-search" @click="reload">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
        <el-button v-if="canCreate" type="primary" icon="el-icon-plus" plain class="fg-add" @click="goAdd">新建订单</el-button>
      </div>
      <div class="fg-row">
        <div class="fg-item">
          <span class="fg-label">退款状态</span>
          <el-select v-model="refundStatus" placeholder="全部退款状态" clearable style="width: 160px" @change="reload">
            <el-option v-for="t in refundStatusTabs" :key="String(t.value)" :label="t.label" :value="t.value" />
          </el-select>
        </div>
        <div class="fg-item">
          <span class="fg-label">下单时间</span>
          <el-date-picker
            v-model="range"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px"
            @change="reload"
          />
        </div>
        <template v-if="isCompany">
          <div class="fg-item">
            <span class="fg-label">战队</span>
            <el-select v-model="filterUnitId" placeholder="全部战队" clearable style="width: 150px" @change="onUnitChange">
              <el-option v-for="u in saleUnits" :key="u.id" :label="u.name" :value="u.id" />
            </el-select>
          </div>
          <div class="fg-item">
            <span class="fg-label">小组</span>
            <el-select v-model="filterTeamId" placeholder="全部小组" clearable style="width: 150px" @change="onTeamChange">
              <el-option v-for="t in saleTeams" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </div>
          <div class="fg-item">
            <span class="fg-label">销售</span>
            <el-select v-model="staffId" placeholder="全部销售" clearable style="width: 150px" @change="reload">
              <el-option v-for="s in salesStaffs" :key="s.id" :label="s.name" :value="s.id" />
            </el-select>
          </div>
        </template>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        :row-style="{ cursor: 'pointer' }"
        empty-text="暂无订单数据"
        @row-click="goDetail"
      >
        <el-table-column prop="order_sn" label="订单号" min-width="160">
          <template slot-scope="{ row }">
            <span class="sn-text">{{ row.order_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户" min-width="150">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">{{ row.customer_name || '未填写' }}</div>
              <div class="cell-name-sub">{{ row.customer_phone || '未留手机号' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="售价" min-width="90" align="right">
          <template slot-scope="{ row }">
            <span class="price-text">¥{{ row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已回款" min-width="90" align="right">
          <template slot-scope="{ row }">
            <span class="paid-text">¥{{ row.paid_amount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业绩" min-width="90" align="right">
          <template slot-scope="{ row }">
            <span class="perform-text">¥{{ row.perform_amount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="staff_name" label="销售" min-width="90">
          <template slot-scope="{ row }">
            <span>{{ row.staff_name || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" min-width="100">
          <template slot-scope="{ row }">
            <el-tag :type="refundTagType(row.refund_status)" size="small">{{ row.refund_status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{ row }">
            <span class="cell-time">{{ formatDateTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click.stop="openBill(row)">收款</el-button>
            <el-button type="text" size="small" @click.stop="openInstallment(row)">办分期</el-button>
            <el-button type="text" size="small" @click.stop="openRefund(row)">退款</el-button>
            <el-button type="text" size="small" @click.stop="goDetail(row)">详情</el-button>
            <el-dropdown trigger="click" @command="(cmd) => handleCommand(cmd, row)">
              <span class="more-link" @click.stop>更多<i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="detail">详情</el-dropdown-item>
                <el-dropdown-item command="edit" v-if="isManager">修改订单</el-dropdown-item>
                <el-dropdown-item command="editProduct" v-if="isManager">修改下单商品</el-dropdown-item>
                <el-dropdown-item command="transfer" v-if="isCompany">转移给其它销售</el-dropdown-item>
                <el-dropdown-item command="markWechat">标记已加微信</el-dropdown-item>
                <el-dropdown-item command="markDeal">标记已成交</el-dropdown-item>
                <el-dropdown-item command="trajectory">订单轨迹</el-dropdown-item>
                <el-dropdown-item command="delete" v-if="isManager" divided>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pager-row">
        <div class="pager-info-left" v-if="total > 0">
          <span class="info-tag">
            显示第 <span class="num">{{ (page - 1) * limit + 1 }}</span> -
            <span class="num">{{ Math.min(page * limit, total) }}</span> 条，
            共 <span class="num">{{ total }}</span> 条记录
          </span>
        </div>
        <el-pagination
          background
          :layout="pagerLayout"
          :pager-count="7"
          :total="total"
          :current-page.sync="page"
          :page-size.sync="limit"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="onSizeChange"
          @current-change="loadData"
        />
      </div>
    </el-card>

    <!-- 订单详情弹框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detailVisible"
      width="620px"
      custom-class="order-detail-dialog"
    >
      <div v-loading="detailLoading" class="detail-body">
        <template v-if="detail.id">
          <!-- 头部 -->
          <div class="detail-head">
            <div class="head-sn-row">
              <span class="head-sn">{{ detail.order_sn }}</span>
              <el-tag :type="parseInt(detail.status) === 2 ? 'success' : 'warning'" size="small">{{ detail.status_text }}</el-tag>
              <el-tag v-if="parseInt(detail.refund_status) > 0" :type="parseInt(detail.refund_status) === 2 ? 'danger' : 'warning'" size="small" effect="plain">{{ detail.refund_status_text }}</el-tag>
            </div>
            <div class="head-customer">
              <div class="head-avatar">{{ (detail.customer_name || '客').substring(0, 1) }}</div>
              <div class="head-customer-info">
                <div class="head-customer-name">{{ detail.customer_name || '未填写' }}</div>
                <div class="head-customer-sub">{{ detail.customer_phone || '未留手机号' }}</div>
              </div>
              <div class="head-price">
                <div class="head-price-label">{{ detail.product_name || '—' }}</div>
                <div class="head-price-num">¥{{ detail.price }}</div>
              </div>
            </div>
          </div>

          <!-- 基本信息 -->
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">商品</span>
              <span class="info-value">{{ detail.product_name || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">归属销售</span>
              <span class="info-value">{{ detail.staff_name || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">量账号</span>
              <span class="info-value">{{ detail.liang_account || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">所在地区</span>
              <span class="info-value">{{ areaText || '—' }}</span>
            </div>
            <div v-if="detail.lead_id" class="info-row">
              <span class="info-label">关联线索</span>
              <span class="info-value">#{{ detail.lead_id }}</span>
            </div>
            <div v-if="detail.agreement_id" class="info-row">
              <span class="info-label">关联协议</span>
              <span class="info-value">#{{ detail.agreement_id }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">创建时间</span>
              <span class="info-value">{{ formatDateTime(detail.createtime) }}</span>
            </div>
            <div v-if="refundedAmount > 0" class="info-row">
              <span class="info-label">已退款金额</span>
              <span class="info-value info-value-refund">-¥{{ refundedAmount }}</span>
            </div>
            <div v-if="detail.remark" class="info-row info-row-block">
              <span class="info-label">备注</span>
              <span class="info-value info-value-block">{{ detail.remark }}</span>
            </div>
          </div>

          <!-- 账单 -->
          <div class="section-card">
            <div class="section-head">
              <span class="section-title">账单</span>
              <span class="section-sub">共 {{ billSummary.total }} 笔 · 已完成 {{ billSummary.done }} 笔 · 合计 ¥{{ billSummary.amount }}</span>
            </div>
            <div v-if="bills.length === 0" class="empty-row">暂无账单</div>
            <div v-for="b in bills" :key="b.id" class="bill-item">
              <div class="bill-item-head">
                <div class="bill-item-left">
                  <el-tag :type="parseInt(b.type) === 2 ? 'warning' : 'primary'" size="mini" effect="plain">
                    {{ parseInt(b.type) === 2 ? ('第' + b.period_no + '期') : '普通收款' }}
                  </el-tag>
                  <span class="bill-sn">{{ b.bill_sn }}</span>
                </div>
                <span class="bill-status" :class="'bill-status-' + b.status">{{ billStatusText(b.status) }}</span>
              </div>
              <div class="bill-item-foot">
                <span class="bill-meta">收款平台：{{ b.paytype_name || '—' }}</span>
                <span class="bill-amount">¥{{ b.amount }}</span>
              </div>
              <div v-if="parseFloat(b.perform_amount) > 0" class="bill-item-foot">
                <span class="bill-meta">核算业绩 ¥{{ b.perform_amount }}（{{ b.perform_date || '—' }}）</span>
              </div>
            </div>
          </div>

          <!-- 分期 -->
          <div v-if="installment" class="section-card">
            <span class="section-title">分期方案</span>
            <div class="info-card-inner">
              <div class="info-row">
                <span class="info-label">分期状态</span>
                <span class="info-value">{{ instStatusText(installment.status) }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">分期总额</span>
                <span class="info-value">¥{{ installment.amount }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">期数</span>
                <span class="info-value">{{ installment.periods }} 期 · 每期 ¥{{ installment.per_amount }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">首次还款日</span>
                <span class="info-value">{{ installment.first_date || '—' }}</span>
              </div>
            </div>
          </div>

          <!-- 退款 -->
          <div v-if="refunds.length > 0" class="section-card">
            <div class="section-head">
              <span class="section-title">退款记录</span>
              <span class="section-sub">已退 ¥{{ refundedAmount }}</span>
            </div>
            <div v-for="r in refunds" :key="r.id" class="bill-item">
              <div class="bill-item-head">
                <span class="bill-sn">{{ r.refund_sn }}</span>
                <span class="bill-status" :class="'refund-status-' + r.status">{{ refundStatusText(r.status) }}</span>
              </div>
              <div class="bill-item-foot">
                <span class="bill-meta">{{ formatDateTime(r.createtime) }}</span>
                <span class="bill-amount bill-amount-refund">-¥{{ r.amount }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="canFinish" type="primary" size="small" :loading="actionLoading" @click="doFinish">完成订单</el-button>
        <el-button v-if="canTransfer" size="small" @click="transferVisible = true">转移订单</el-button>
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 转移销售弹窗 -->
    <el-dialog title="转移给新销售" :visible.sync="transferVisible" width="440px">
      <div class="transfer-body">
        <div v-for="s in transferStaffs" :key="s.id" class="transfer-item" @click="doTransfer(s)">
          <span class="transfer-name">{{ s.name }}</span>
          <span class="transfer-sub">{{ s.id === detail.staff_id ? '当前销售' : (s.work_status_text || '') }}</span>
          <i class="el-icon-right transfer-arrow"></i>
        </div>
        <div v-if="transferStaffs.length === 0" class="empty-row">暂无可转移的销售员工</div>
      </div>
    </el-dialog>

    <!-- 修改订单基本信息 -->
    <el-dialog title="修改订单" :visible.sync="editVisible" width="520px">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px" size="small">
        <el-form-item label="客户姓名" prop="customer_name">
          <el-input v-model="editForm.customer_name" :maxlength="50" />
        </el-form-item>
        <el-form-item label="手机号" prop="customer_phone">
          <el-input v-model="editForm.customer_phone" :maxlength="11" />
        </el-form-item>
        <el-form-item label="省/市/区">
          <div class="addr-row">
            <el-input v-model="editForm.province" placeholder="省" :maxlength="50" />
            <el-input v-model="editForm.city" placeholder="市" :maxlength="50" />
            <el-input v-model="editForm.district" placeholder="区" :maxlength="50" />
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" :maxlength="500" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="editSaving" @click="doEdit">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 修改下单商品 -->
    <el-dialog title="修改下单商品" :visible.sync="editProductVisible" width="480px">
      <el-form :model="editProductForm" :rules="editProductRules" ref="editProductForm" label-width="90px" size="small">
        <el-form-item label="商品" prop="product_id">
          <el-select v-model="editProductForm.product_id" placeholder="选择商品" filterable style="width:100%">
            <el-option v-for="p in productOptions" :key="p.id" :label="`${p.name}（¥${p.price}）`" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="售价" prop="price">
          <el-input-number v-model="editProductForm.price" :min="0" :max="99999999" :precision="2" :step="100" style="width:100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editProductVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="editProductSaving" @click="doEditProduct">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 订单轨迹弹窗 -->
    <el-dialog title="订单轨迹" :visible.sync="trajectoryVisible" width="680px" custom-class="trajectory-dialog">
      <div v-loading="trajectoryLoading" class="trajectory-body">
        <div v-if="trajectoryItems.length === 0 && !trajectoryLoading" class="empty-row">暂无轨迹记录</div>
        <el-timeline v-else>
          <el-timeline-item
            v-for="(item, idx) in trajectoryItems"
            :key="idx"
            :timestamp="item.time_text"
            :color="trajectoryColor(item.type)"
            placement="top"
          >
            <div class="traj-item">
              <div class="traj-title">{{ item.title }}</div>
              <div class="traj-desc" v-if="item.desc">{{ item.desc }}</div>
              <el-tag v-if="item.status_text" size="mini" :type="trajStatusType(item.type)" effect="plain" style="margin-top: 6px;">
                {{ item.status_text }}
              </el-tag>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="trajectoryVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 收款弹窗 -->
    <el-dialog title="收款" :visible.sync="billVisible" width="480px" @closed="resetBillForm">
      <div v-if="curActionRow" class="action-head">
        <span class="action-head-name">{{ curActionRow.customer_name }}</span>
        <span class="action-head-sub">{{ curActionRow.order_sn }}</span>
      </div>
      <el-form ref="billForm" :model="billForm" :rules="billRules" label-width="96px" size="small">
        <el-form-item label="收款平台" prop="paytype_id">
          <el-select v-model="billForm.paytype_id" placeholder="请选择收款平台" style="width: 100%">
            <el-option v-for="pt in paytypes" :key="pt.id" :label="pt.name + '（比例 ' + pt.rate + '）'" :value="pt.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款金额" prop="amount">
          <el-input v-model="billForm.amount" placeholder="0.00" />
        </el-form-item>
        <el-form-item label="第三方单号">
          <el-input v-model="billForm.transaction_id" placeholder="选填" :maxlength="64" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="billForm.remark" type="textarea" :rows="2" placeholder="选填" :maxlength="200" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="billVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="actionLoading" @click="doBillAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 办分期弹窗 -->
    <el-dialog title="办理分期" :visible.sync="installmentVisible" width="480px" @closed="resetInstallmentForm">
      <div v-if="curActionRow" class="action-head">
        <span class="action-head-name">{{ curActionRow.customer_name }}</span>
        <span class="action-head-sub">{{ curActionRow.order_sn }}</span>
      </div>
      <el-form ref="instForm" :model="instForm" :rules="instRules" label-width="96px" size="small">
        <el-form-item label="收款平台" prop="paytype_id">
          <el-select v-model="instForm.paytype_id" placeholder="请选择收款平台" style="width: 100%">
            <el-option v-for="pt in paytypes" :key="pt.id" :label="pt.name + '（比例 ' + pt.rate + '）'" :value="pt.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="分期总额" prop="amount">
          <el-input v-model="instForm.amount" placeholder="0.00" />
        </el-form-item>
        <el-form-item label="期数" prop="periods">
          <el-input-number v-model="instForm.periods" :min="2" :max="12" style="width: 100%" />
        </el-form-item>
        <el-form-item label="首次还款日" prop="first_date">
          <el-date-picker v-model="instForm.first_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" />
        </el-form-item>
        <div v-if="instForm.amount && instForm.periods" class="form-hint-pad">
          每期约 ¥{{ (parseFloat(instForm.amount) / instForm.periods).toFixed(2) }}（末期差额兜底）
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="installmentVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="actionLoading" @click="doInstallmentAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 退款弹窗 -->
    <el-dialog title="申请退款" :visible.sync="refundVisible" width="480px" @closed="resetRefundForm">
      <div v-if="curActionRow" class="action-head">
        <span class="action-head-name">{{ curActionRow.customer_name }}</span>
        <span class="action-head-sub">{{ curActionRow.order_sn }}</span>
      </div>
      <el-form ref="refundForm" :model="refundForm" :rules="refundRules" label-width="96px" size="small">
        <el-form-item label="退款渠道" prop="refund_channel">
          <el-radio-group v-model="refundForm.refund_channel">
            <el-radio :label="1">支付宝</el-radio>
            <el-radio :label="2">微信</el-radio>
            <el-radio :label="3">银行卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款金额" prop="amount">
          <el-input v-model="refundForm.amount" placeholder="0.00" />
        </el-form-item>
        <el-form-item label="第三方单号">
          <el-input v-model="refundForm.transaction_id" placeholder="选填" :maxlength="64" />
        </el-form-item>
        <el-form-item label="退款凭证">
          <el-upload
            class="refund-voucher-uploader"
            action="/api/upload/index"
            name="file"
            :headers="uploadHeaders"
            :show-file-list="false"
            accept="image/*"
            :on-success="onVoucherSuccess"
            :on-error="() => $message.error('凭证上传失败')"
          >
            <img v-if="refundForm.voucher" :src="refundForm.voucher" class="refund-voucher-preview" />
            <i v-else class="el-icon-plus refund-voucher-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="actionLoading" @click="doRefundAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderList, orderDetail, orderFinish, orderTransfer, orderDelete, orderEdit, orderEditProduct, orderTrajectory, orderMarkWechat, orderMarkDeal } from '@/api/order'
import { unitList, teamList, staffList } from '@/api/org'
import { paytypeList, productList } from '@/api/base'
import { billAdd } from '@/api/bill'
import { installmentAdd } from '@/api/installment'
import { refundAdd } from '@/api/refund'

const BILL_STATUS = ['未出账', '已出账', '待审核', '审核失败', '已完成', '已逾期', '已还款']
const INST_STATUS = { 1: '待审核', 2: '进行中', 3: '已逾期', 4: '已退款', 5: '已完成', 6: '未通过' }
const REFUND_STATUS = { 1: '待审核', 2: '已完成', 3: '未通过' }

export default {
  name: 'OrderList',
  data() {
    return {
      keyword: '',
      refundStatus: '',
      refundStatusTabs: [
        { label: '全部', value: '' },
        { label: '无退款', value: 0 },
        { label: '退款中', value: 1 },
        { label: '部分退款', value: 2 },
        { label: '已退款', value: 3 }
      ],
      staffId: null,
      range: null,
      filterUnitId: null,
      filterTeamId: null,
      saleUnits: [],
      saleTeams: [],
      salesStaffs: [],
      list: [],
      page: 1,
      limit: 20,
      total: 0,
      loading: false,
      // 详情
      detailVisible: false,
      detailLoading: false,
      detail: {},
      bills: [],
      installment: null,
      refunds: [],
      billSummary: { total: 0, done: 0, amount: 0 },
      actionLoading: false,
      // 转移
      transferVisible: false,
      transferStaffs: [],
      // 修改订单基本信息
      editVisible: false,
      editSaving: false,
      editForm: { id: 0, customer_name: '', customer_phone: '', province: '', city: '', district: '', remark: '' },
      editRules: {
        customer_name: [
          { required: true, message: '请填写客户姓名', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ],
        customer_phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      },
      // 修改下单商品
      editProductVisible: false,
      editProductSaving: false,
      editProductForm: { id: 0, product_id: null, price: 0 },
      editProductRules: {
        product_id: [{ required: true, message: '请选择商品', trigger: 'change' }],
        price: [{ required: true, message: '请填售价', trigger: 'change' }]
      },
      productOptions: [],
      // 轨迹
      trajectoryVisible: false,
      trajectoryLoading: false,
      trajectoryItems: [],
      // 收款平台（快捷操作弹窗用）
      paytypes: [],
      curActionRow: null,
      // 收款
      billVisible: false,
      billForm: { order_id: 0, paytype_id: null, amount: '', transaction_id: '', remark: '' },
      billRules: {
        paytype_id: [{ required: true, message: '请选择收款平台', trigger: 'change' }],
        amount: [{ required: true, message: '请填写收款金额', trigger: 'blur' }]
      },
      // 办分期
      installmentVisible: false,
      instForm: { order_id: 0, paytype_id: null, amount: '', periods: 3, first_date: '' },
      instRules: {
        paytype_id: [{ required: true, message: '请选择收款平台', trigger: 'change' }],
        amount: [{ required: true, message: '请填写分期总额', trigger: 'blur' }],
        periods: [{ required: true, message: '请填分期期数', trigger: 'change' }],
        first_date: [{ required: true, message: '请选择首次还款日', trigger: 'change' }]
      },
      // 退款
      refundVisible: false,
      refundForm: { order_id: 0, refund_channel: 1, amount: '', transaction_id: '', voucher: '' },
      refundRules: {
        refund_channel: [{ required: true, message: '请选择退款渠道', trigger: 'change' }],
        amount: [{ required: true, message: '请填写退款金额', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState(['user']),
    isCompany() {
      return !!(this.user && this.user.type === 'company')
    },
    /* 可管理（编辑/删除）订单：机构管理员 或 战队长(unit) / 小组长(team)（本范围） */
    isManager() {
      if (!this.user) return false
      return this.user.type === 'company' || this.user.type === 'unit' || this.user.type === 'team'
    },
    /* 可创建订单：机构管理员 或 销售员工（非推广） */
    canCreate() {
      if (!this.user) return false
      if (this.user.type === 'company') return true
      return this.user.type === 'staff' && parseInt(this.user.is_promo) !== 1
    },
    pagerLayout() {
      return 'total, sizes, prev, pager, next, jumper'
    },
    areaText() {
      if (!this.detail) return ''
      return [this.detail.province, this.detail.city, this.detail.district].filter(Boolean).join(' ')
    },
    /* 已退款金额（退款中 + 已完成，与列表口径一致） */
    refundedAmount() {
      if (!this.refunds || this.refunds.length === 0) return 0
      return this.refunds
        .filter(r => parseInt(r.status) === 1 || parseInt(r.status) === 2)
        .reduce((sum, r) => sum + parseFloat(r.amount), 0)
        .toFixed(2)
    },
    /* 完成订单：机构管理员 或 队长（is_leader） */
    canFinish() {
      if (!this.user || parseInt(this.detail.status) !== 1) return false
      if (this.user.type === 'company') return true
      return this.user.type === 'staff' && parseInt(this.user.is_leader) === 1
    },
    /* 转移订单：仅机构管理员且进行中 */
    canTransfer() {
      return this.isCompany && parseInt(this.detail.status) === 1
    },
    /* 凭证上传鉴权头 */
    uploadHeaders() {
      const token = this.$store.state.token || localStorage.getItem('crm_token') || ''
      return { Token: token }
    }
  },
  created() {
    if (this.isCompany) this.loadSalesStaffs()
    this.loadPaytypes()
    this.reload()
  },
  methods: {
    /* ===== 数据加载 ===== */
    reload() {
      this.page = 1
      this.loadData()
    },
    loadData() {
      if (this.loading) return
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.keyword) params.keyword = this.keyword
      if (this.refundStatus !== '') params.refund_status = this.refundStatus
      if (this.staffId) params.staff_id = this.staffId
      if (this.range && this.range.length === 2) {
        params.start_date = this.range[0]
        params.end_date = this.range[1]
      }
      if (this.filterUnitId) params.unit_id = this.filterUnitId
      if (this.filterTeamId) params.team_id = this.filterTeamId
      orderList(params)
        .then(data => {
          this.list = data.list || []
          this.total = data.total || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadPaytypes() {
      paytypeList({})
        .then(data => { this.paytypes = data.list || [] })
        .catch(() => {})
    },
    loadSalesStaffs() {
      unitList()
        .then(du => {
          this.saleUnits = (du.list || []).filter(u => parseInt(u.type) === 2)
          return staffList({}).then(ds => ({ ds }))
        })
        .then(({ ds }) => {
          this.salesStaffs = (ds.list || []).filter(s => this.inSaleUnit(s) && parseInt(s.status) === 1)
        })
        .catch(() => {})
    },
    inSaleUnit(s) {
      return this.saleUnits.some(u => parseInt(u.id) === parseInt(s.unit_id))
    },
    /* 战队变化：重置小组/员工级联 */
    onUnitChange() {
      this.filterTeamId = null
      this.staffId = null
      if (!this.filterUnitId) {
        this.saleTeams = []
        this.salesStaffs = []
        this.loadSalesStaffs()
        this.reload()
        return
      }
      teamList({ unit_id: this.filterUnitId })
        .then(dt => {
          this.saleTeams = dt.list || []
          return staffList({ unit_id: this.filterUnitId }).then(ds => ({ ds }))
        })
        .then(({ ds }) => {
          this.salesStaffs = (ds.list || []).filter(s => parseInt(s.status) === 1)
        })
        .catch(() => {})
        .finally(() => this.reload())
    },
    /* 小组变化：加载该小组员工 */
    onTeamChange() {
      this.staffId = null
      if (!this.filterTeamId) {
        this.salesStaffs = []
        this.reload()
        return
      }
      staffList({ team_id: this.filterTeamId })
        .then(ds => {
          this.salesStaffs = (ds.list || []).filter(s => parseInt(s.status) === 1)
        })
        .catch(() => {})
        .finally(() => this.reload())
    },
    resetFilters() {
      this.keyword = ''
      this.refundStatus = ''
      this.staffId = null
      this.range = null
      this.filterUnitId = null
      this.filterTeamId = null
      this.saleTeams = []
      if (this.isCompany) this.loadSalesStaffs()
      this.reload()
    },
    onSizeChange(size) {
      this.limit = size
      this.reload()
    },
    /* ===== 详情 ===== */
    goDetail(row) {
      this.detail = {}
      this.bills = []
      this.installment = null
      this.refunds = []
      this.billSummary = { total: 0, done: 0, amount: 0 }
      this.detailVisible = true
      this.loadDetail(row.id)
    },
    loadDetail(id) {
      this.detailLoading = true
      orderDetail(id)
        .then(data => {
          this.detail = data.order || {}
          this.bills = data.bills || []
          this.installment = data.installment || null
          this.refunds = data.refunds || []
          this.billSummary = data.bill_summary || { total: 0, done: 0, amount: 0 }
          if (this.isCompany && this.canTransfer) this.loadTransferStaffs()
        })
        .catch(() => {
          this.detailVisible = false
        })
        .finally(() => { this.detailLoading = false })
    },
    loadTransferStaffs() {
      unitList()
        .then(du => {
          const saleUnitIds = (du.list || []).filter(u => parseInt(u.type) === 2).map(u => parseInt(u.id))
          return staffList({}).then(ds => ({ ds, saleUnitIds }))
        })
        .then(({ ds, saleUnitIds }) => {
          this.transferStaffs = (ds.list || []).filter(s => saleUnitIds.indexOf(parseInt(s.unit_id)) > -1 && parseInt(s.status) === 1)
        })
        .catch(() => {})
    },
    /* ===== 完成订单 ===== */
    doFinish() {
      this.$confirm('确认将此订单标记为已完成？须无未完成账单。', '完成订单', {
        confirmButtonText: '完 成',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.actionLoading = true
        orderFinish(this.detail.id)
          .then(() => {
            this.$message.success('订单已完成')
            this.loadDetail(this.detail.id)
            this.loadData()
          })
          .catch(() => {})
          .finally(() => { this.actionLoading = false })
      }).catch(() => {})
    },
    /* ===== 转移订单 ===== */
    doTransfer(s) {
      this.$confirm(`确认将订单转移给「${s.name}」？未完成账单业绩将同步转移。`, '转移订单', {
        confirmButtonText: '转 移',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        orderTransfer(this.detail.id, s.id)
          .then(() => {
            this.$message.success('转移成功')
            this.transferVisible = false
            this.loadDetail(this.detail.id)
            this.loadData()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    /* ===== 跳转新建订单 ===== */
    goAdd() {
      this.$router.push('/order/add')
    },
    /* ===== 修改订单基本信息 ===== */
    openEdit(row) {
      this.editForm = {
        id: row.id,
        customer_name: row.customer_name || '',
        customer_phone: row.customer_phone || '',
        province: row.province || '',
        city: row.city || '',
        district: row.district || '',
        remark: row.remark || ''
      }
      this.editVisible = true
    },
    doEdit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        this.editSaving = true
        orderEdit({
          id: this.editForm.id,
          customer_name: this.editForm.customer_name.trim(),
          customer_phone: this.editForm.customer_phone.trim(),
          province: this.editForm.province,
          city: this.editForm.city,
          district: this.editForm.district,
          remark: this.editForm.remark
        })
          .then(() => {
            this.$message.success('修改成功')
            this.editVisible = false
            this.reload()
          })
          .catch(() => {})
          .finally(() => { this.editSaving = false })
      })
    },
    /* ===== 修改下单商品 ===== */
    openEditProduct(row) {
      this.editProductForm = { id: row.id, product_id: row.product_id || null, price: parseFloat(row.price) || 0 }
      this.loadProducts()
      this.editProductVisible = true
    },
    loadProducts() {
      productList({ status: 1 })
        .then(data => { this.productOptions = data.list || [] })
        .catch(() => { this.productOptions = [] })
    },
    doEditProduct() {
      this.$refs.editProductForm.validate(valid => {
        if (!valid) return
        this.editProductSaving = true
        orderEditProduct({
          id: this.editProductForm.id,
          product_id: this.editProductForm.product_id,
          price: this.editProductForm.price
        })
          .then(() => {
            this.$message.success('修改成功')
            this.editProductVisible = false
            this.reload()
          })
          .catch(() => {})
          .finally(() => { this.editProductSaving = false })
      })
    },
    /* ===== 下拉菜单命令 ===== */
    handleCommand(cmd, row) {
      switch (cmd) {
        case 'detail':
          this.goDetail(row)
          break
        case 'edit':
          this.openEdit(row)
          break
        case 'editProduct':
          this.openEditProduct(row)
          break
        case 'transfer':
          this.goDetail(row)
          this.transferVisible = true
          break
        case 'markWechat':
          this.doMarkWechat(row)
          break
        case 'markDeal':
          this.doMarkDeal(row)
          break
        case 'trajectory':
          this.showTrajectory(row)
          break
        case 'delete':
          this.doDelete(row)
          break
        default:
          this.goDetail(row)
      }
    },
    /* ===== 收款 ===== */
    openBill(row) {
      this.curActionRow = row
      this.billForm = { order_id: row.id, paytype_id: row.paytype_id || null, amount: String(row.price), transaction_id: '', remark: '' }
      this.billVisible = true
    },
    resetBillForm() {
      this.billForm = { order_id: 0, paytype_id: null, amount: '', transaction_id: '', remark: '' }
      this.$refs.billForm && this.$refs.billForm.clearValidate()
    },
    doBillAdd() {
      this.$refs.billForm.validate(valid => {
        if (!valid) return
        this.actionLoading = true
        billAdd({
          order_id: this.billForm.order_id,
          paytype_id: this.billForm.paytype_id,
          amount: this.billForm.amount,
          transaction_id: (this.billForm.transaction_id || '').trim(),
          in_perform: 1
        })
          .then(() => {
            this.$message.success('收款录入成功，待审核')
            this.billVisible = false
            this.loadData()
          })
          .catch(() => {})
          .finally(() => { this.actionLoading = false })
      })
    },
    /* ===== 办分期 ===== */
    openInstallment(row) {
      this.curActionRow = row
      const today = new Date()
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate())
      const p = n => (n < 10 ? '0' + n : '' + n)
      this.instForm = {
        order_id: row.id,
        paytype_id: row.paytype_id || null,
        amount: String(row.price),
        periods: 3,
        first_date: `${nextMonth.getFullYear()}-${p(nextMonth.getMonth() + 1)}-${p(nextMonth.getDate())}`
      }
      this.installmentVisible = true
    },
    resetInstallmentForm() {
      this.instForm = { order_id: 0, paytype_id: null, amount: '', periods: 3, first_date: '' }
      this.$refs.instForm && this.$refs.instForm.clearValidate()
    },
    doInstallmentAdd() {
      this.$refs.instForm.validate(valid => {
        if (!valid) return
        this.actionLoading = true
        installmentAdd({
          order_id: this.instForm.order_id,
          paytype_id: this.instForm.paytype_id,
          amount: this.instForm.amount,
          periods: this.instForm.periods,
          first_date: this.instForm.first_date
        })
          .then(() => {
            this.$message.success('分期申请成功，待审核')
            this.installmentVisible = false
            this.loadData()
          })
          .catch(() => {})
          .finally(() => { this.actionLoading = false })
      })
    },
    /* ===== 退款 ===== */
    openRefund(row) {
      this.curActionRow = row
      this.refundForm = { order_id: row.id, refund_channel: 1, amount: '', transaction_id: '', voucher: '' }
      this.refundVisible = true
    },
    resetRefundForm() {
      this.refundForm = { order_id: 0, refund_channel: 1, amount: '', transaction_id: '', voucher: '' }
      this.$refs.refundForm && this.$refs.refundForm.clearValidate()
    },
    onVoucherSuccess(res) {
      if (res && res.data && res.data.url) {
        this.refundForm.voucher = res.data.url
        this.$message.success('凭证上传成功')
      } else {
        this.$message.error('凭证上传失败')
      }
    },
    doRefundAdd() {
      this.$refs.refundForm.validate(valid => {
        if (!valid) return
        this.actionLoading = true
        refundAdd({
          order_id: this.refundForm.order_id,
          refund_channel: this.refundForm.refund_channel,
          amount: this.refundForm.amount,
          transaction_id: (this.refundForm.transaction_id || '').trim(),
          voucher: this.refundForm.voucher || ''
        })
          .then(() => {
            this.$message.success('退款申请成功，待审核')
            this.refundVisible = false
            this.loadData()
          })
          .catch(() => {})
          .finally(() => { this.actionLoading = false })
      })
    },
    /* ===== 订单轨迹 ===== */
    showTrajectory(row) {
      this.trajectoryVisible = true
      this.trajectoryLoading = true
      this.trajectoryItems = []
      orderTrajectory(row.id)
        .then(data => {
          this.trajectoryItems = data.items || []
        })
        .catch(() => {
          this.trajectoryItems = []
        })
        .finally(() => {
          this.trajectoryLoading = false
        })
    },
    trajectoryColor(type) {
      const colorMap = {
        order_create: '#3668FC',
        installment: '#E8930C',
        installment_audit: '#16A34A',
        installment_reject: '#E5484D',
        bill_create: '#3668FC',
        bill_audit: '#16A34A',
        bill_reject: '#E5484D',
        bill_overdue: '#E5484D',
        bill_repaid: '#16A34A',
        refund_create: '#E8930C',
        refund_audit: '#16A34A',
        refund_reject: '#E5484D'
      }
      return colorMap[type] || '#C3CADB'
    },
    trajStatusType(type) {
      if (type.indexOf('reject') > -1) return 'danger'
      if (type.indexOf('overdue') > -1) return 'danger'
      if (type.indexOf('audit') > -1 || type.indexOf('repaid') > -1) return 'success'
      if (type === 'installment' || type === 'refund_create') return 'warning'
      return 'info'
    },
    /* ===== 推广侧状态同步 ===== */
    doMarkWechat(row) {
      this.$confirm(`确认将「${row.customer_name}」标记为已加微信？将同步到推广线索。`, '标记已加微信', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        orderMarkWechat(row.id)
          .then(() => { this.$message.success('已标记已加微信'); this.reload() })
          .catch(() => {})
      }).catch(() => {})
    },
    doMarkDeal(row) {
      this.$confirm(`确认将「${row.customer_name}」标记为已成交？将同步到推广线索。`, '标记已成交', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        orderMarkDeal(row.id)
          .then(() => { this.$message.success('已标记已成交'); this.reload() })
          .catch(() => {})
      }).catch(() => {})
    },
    /* ===== 删除订单 ===== */
    doDelete(row) {
      this.$confirm(`确认删除订单「${row.customer_name}」？删除后不可恢复。`, '删除订单', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        orderDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.reload()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    /* ===== 工具 ===== */
    billStatusText(s) {
      return BILL_STATUS[parseInt(s)] || '未知'
    },
    instStatusText(s) {
      return INST_STATUS[parseInt(s)] || '未知'
    },
    refundStatusText(s) {
      return REFUND_STATUS[parseInt(s)] || '未知'
    },
    refundTagType(s) {
      const v = parseInt(s)
      if (v === 1) return 'warning'
      if (v === 2) return 'danger'
      if (v === 3) return 'info'
      return 'info'
    },
    formatDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.order-page {
  padding: 0;
}

/* ===== 筛选栏 ===== */
.filter-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.fg-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-bottom: 12px;
}

.fg-row:last-child { margin-bottom: 0; }

.fg-search { width: 260px; }
.fg-add { margin-left: auto; }

.fg-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fg-label { font-size: 13px; color: #8A94AD; flex-shrink: 0; }

/* ===== 表格卡片 ===== */
.table-card {
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.sn-text {
  font-size: 12px;
  color: #5A6580;
  font-family: monospace;
  font-variant-numeric: tabular-nums;
}

.cell-name-main {
  min-width: 0;
}

.cell-name-text {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #18233C;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-name-sub {
  display: block;
  font-size: 11px;
  color: #8A94AD;
  margin-top: 2px;
}

.price-text {
  font-size: 13px;
  font-weight: 600;
  color: #E8930C;
  font-variant-numeric: tabular-nums;
}

.paid-text {
  font-size: 13px;
  font-weight: 600;
  color: #16A34A;
  font-variant-numeric: tabular-nums;
}

.info-value-refund {
  color: #E5484D;
  font-weight: 600;
}

.perform-text {
  font-size: 13px;
  font-weight: 600;
  color: #3668FC;
  font-variant-numeric: tabular-nums;
}

/* 操作列更多按钮 */
.more-link {
  color: #3668FC;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 4px;
}

.more-link:hover { color: #5B8DFF; }

/* 快捷操作弹窗头部 */
.action-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  background: #F5F8FF;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 14px;
}

.action-head-name {
  font-size: 14px;
  font-weight: 600;
  color: #18233C;
}

.action-head-sub {
  font-size: 12px;
  color: #8A94AD;
  font-family: monospace;
}

.form-hint-pad {
  padding-left: 96px;
  font-size: 12px;
  color: #8A94AD;
  margin-bottom: 8px;
}

/* 退款凭证上传 */
.refund-voucher-uploader :deep(.el-upload) {
  width: 96px;
  height: 96px;
  border: 1px dashed #C3CADB;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFBFF;
  transition: border-color 0.2s;
}
.refund-voucher-uploader :deep(.el-upload:hover) { border-color: #3668FC; }
.refund-voucher-icon { font-size: 24px; color: #8A94AD; }
.refund-voucher-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cell-time {
  font-size: 12px;
  color: #5A6580;
  font-variant-numeric: tabular-nums;
}

/* 分页器行 */
.pager-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 8px 8px;
  border-top: 1px solid #F2F4F8;
  margin-top: 4px;
}

.pager-info-left {
  font-size: 12px;
  color: #8A94AD;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: #F4F6FB;
  border-radius: 6px;
  color: #5A6580;
  font-variant-numeric: tabular-nums;
}

.info-tag .num { color: #3668FC; font-weight: 600; margin: 0 2px; }

/* ===== 详情弹框 ===== */
.detail-body { min-height: 100px; }

.detail-head {
  background: linear-gradient(135deg, #3668FC 0%, #2952D8 60%, #5B8DFF 120%);
  border-radius: 12px;
  padding: 16px 20px;
  color: #FFF;
}

.head-sn-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.30);
}

.head-sn {
  font-size: 12px;
  font-family: monospace;
  opacity: 0.9;
}

.head-customer {
  display: flex;
  align-items: center;
  padding-top: 14px;
}

.head-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.40);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.head-customer-info { flex: 1; min-width: 0; margin-left: 12px; }

.head-customer-name {
  display: block;
  font-size: 16px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head-customer-sub {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.85;
}

.head-price { text-align: right; flex-shrink: 0; }

.head-price-label {
  display: block;
  font-size: 12px;
  opacity: 0.85;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head-price-num {
  display: block;
  margin-top: 4px;
  font-size: 22px;
  font-weight: 700;
}

/* 信息卡 */
.info-card {
  margin-top: 12px;
  border: 1px solid #E5E9F2;
  border-radius: 10px;
  padding: 0 16px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 11px 0;
  border-bottom: 1px solid #F2F4F8;
}

.info-row:last-child { border-bottom: none; }

.info-row-block { flex-direction: column; gap: 6px; }

.info-label { font-size: 12px; color: #8A94AD; flex-shrink: 0; }

.info-value {
  font-size: 13px;
  color: #2B3653;
  text-align: right;
  word-break: break-all;
  margin-left: 16px;
}

.info-value-block { text-align: left; margin-left: 0; line-height: 1.6; }

/* 区块卡 */
.section-card {
  margin-top: 12px;
  border: 1px solid #E5E9F2;
  border-radius: 10px;
  padding: 12px 16px 0;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #18233C;
  display: inline-flex;
  align-items: center;
}

.section-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(180deg, #3668FC, #5B8DFF);
  margin-right: 8px;
}

.section-sub { font-size: 12px; color: #8A94AD; }

.info-card-inner { padding: 0; }

.bill-item {
  border-bottom: 1px solid #F2F4F8;
  padding: 12px 0;
}

.bill-item:last-child { border-bottom: none; }

.bill-item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.bill-item-left { display: flex; align-items: center; gap: 8px; min-width: 0; }

.bill-sn {
  font-size: 11px;
  color: #8A94AD;
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bill-status {
  font-size: 12px;
  flex-shrink: 0;
  font-weight: 600;
}

.bill-status-0 { color: #B4BDCF; }
.bill-status-1 { color: #5A6580; }
.bill-status-2 { color: #E8930C; }
.bill-status-3 { color: #E5484D; }
.bill-status-4 { color: #16A34A; }
.bill-status-5 { color: #E5484D; }
.bill-status-6 { color: #16A34A; }

.refund-status-1 { color: #E8930C; }
.refund-status-2 { color: #16A34A; }
.refund-status-3 { color: #B4BDCF; }

.bill-item-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.bill-meta { font-size: 12px; color: #8A94AD; }

.bill-amount {
  font-size: 14px;
  font-weight: 700;
  color: #18233C;
  font-variant-numeric: tabular-nums;
}

.bill-amount-refund { color: #E5484D; }

.empty-row {
  padding: 24px 0;
  text-align: center;
  font-size: 12px;
  color: #B4BDCF;
}

/* 转移弹窗 */
.transfer-body {
  max-height: 320px;
  overflow-y: auto;
}

.addr-row { display: flex; gap: 8px; }
.addr-row .el-input { flex: 1; }

.transfer-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.transfer-item:hover { background: #F5F8FF; }

.transfer-name {
  font-size: 13px;
  font-weight: 600;
  color: #18233C;
}

.transfer-sub { font-size: 12px; color: #8A94AD; flex: 1; }

.transfer-arrow { font-size: 14px; color: #C3CADB; }

/* ===== 订单轨迹弹窗 ===== */
.trajectory-body {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px 0;
}

.traj-item {
  padding: 4px 0;
}

.traj-title {
  font-size: 14px;
  font-weight: 600;
  color: #18233C;
}

.traj-desc {
  font-size: 12px;
  color: #5A6580;
  margin-top: 4px;
  line-height: 1.5;
}

::v-deep .trajectory-dialog .el-timeline-item__timestamp {
  color: #8A94AD;
  font-size: 12px;
}

::v-deep .trajectory-dialog .el-timeline-item__node {
  left: -1px;
}

::v-deep .trajectory-dialog .el-timeline-item__content {
  padding-bottom: 16px;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary {
  background: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }

::v-deep .el-button--primary.is-plain {
  color: #3668FC;
  background: #EDF3FE;
  border-color: #C8D6FA;
}

::v-deep .el-button--primary.is-plain:hover,
::v-deep .el-button--primary.is-plain:focus {
  background: #3668FC;
  border-color: #3668FC;
  color: #FFF;
}

::v-deep .el-table__row:hover > td {
  background: #F5F8FF !important;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-dialog {
  border-radius: 12px;
}
</style>
